'use client';

import { startTransition, useEffect, useState } from 'react';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { InstallmentCalculatorDialog } from '@packages/installment-calculator/src/InstallmentCalculatorDialog/InstallmentCalculatorDialog.client';
import { useInstallmentCalculatorTracking } from '../../../Tracking/hooks/useInstallmentCalculatorTracking/useInstallmentCalculatorTracking';
import { Layout1 } from '../Layout1/Layout1.client';
import { Layout2 } from '../Layout2/Layout2.client';
import { Layout3 } from '../Layout3/Layout3.client';

export type InstallmentCalulatorInDialogProps = {
  /**
   * the single installment value from the calculation result as integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * Product price value as int (e.g. 1337)
   */
  basePrice: number;
};

export const InstallmentCalulatorInDialog = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  basePrice,
}: InstallmentCalulatorInDialogProps) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  const { trackGlycerinDisplayLink, trackDialogOpen } = useInstallmentCalculatorTracking();

  useEffect(() => {
    trackGlycerinDisplayLink();
  }, [trackGlycerinDisplayLink]);

  useEffect(() => {
    if (dialogOpened) {
      trackDialogOpen();
    }
  }, [dialogOpened, trackDialogOpen]);

  return (
    <>
      <InstallmentCalculatorDialog
        basePrice={basePrice}
        hasEditablePrice
        isOpen={dialogOpened}
        onClose={() => startTransition(() => setDialogOpened(false))}
      />
      {(() => {
        switch (InstallmentCalculatorCallToActionLayout?.layout) {
          case 'Layout1': {
            return (
              <Layout1
                singleInstallment={singleInstallment}
                currency={currency}
                numberOfInstallments={numberOfInstallments}
                openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
              />
            );
          }
          case 'Layout2': {
            return (
              <Layout2
                singleInstallment={singleInstallment}
                currency={currency}
                numberOfInstallments={numberOfInstallments}
                openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
              />
            );
          }
          case 'Layout3': {
            return (
              <Layout3
                singleInstallment={singleInstallment}
                currency={currency}
                openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
              />
            );
          }
          default:
            return null;
        }
      })()}
    </>
  );
};
